let getters = {
    all:               state => {
        return state.all;
    },
    cachedAll:         state => {
        return state.cachedAll;
    },
    tasks:             state => {
        return state.tasks;
    },
    statuses:          state => {
        return state.statuses;
    },
    absenceTypes:      state => {
        return state.absenceTypes;
    },
    slotTitleSettings: state => {
        return state.slotTitleSettings;
    },
    groups:            state => {
        return state.groups;
    },
    ghostGroup:        state => {
        return state.ghostGroup;
    },
    fullDayAbsences:   state => {
        return state.fullDayAbsences;
    },
    partDayAbsences:   state => {
        return state.partDayAbsences;
    },
    weekSchedules:     state => {
        return state.weekSchedules;
    },
    updated:           state => {
        return state.updated;
    },
    draggingGroup:     state => {
        return state.draggingGroup;
    },
    person:            state => {
        return state.person;
    },
    canBeManaged:      state => {
        return state.draggingGroup;
    },
    planning:          state => {
        return state.planning;
    }
};

export default getters;